var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCancel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99992 4.99999C5.39045 4.60946 6.02361 4.60946 6.41414 4.99998L11.9999 10.5858L17.5857 4.99998C17.9762 4.60946 18.6094 4.60946 18.9999 4.99999C19.3904 5.39051 19.3904 6.02368 18.9999 6.4142L13.4141 12L18.9999 17.5858C19.3904 17.9763 19.3904 18.6095 18.9999 19C18.6094 19.3905 17.9762 19.3905 17.5857 19L11.9999 13.4142L6.41414 19C6.02361 19.3905 5.39045 19.3905 4.99992 19C4.6094 18.6095 4.6094 17.9763 4.99992 17.5858L10.5857 12L4.99992 6.4142C4.6094 6.02368 4.6094 5.39051 4.99992 4.99999Z",
    fill: "currentColor"
  })));
}

export default SvgCancel;